import React from "react";
import { connect } from 'react-redux';
import { createErrorEmail } from '../redux/reducer/stepReducer/thunks.js'


export class ApplicationError extends Error {
    constructor(message) {
        super(message)
        this.name = 'ApplicationError'
    }
};

class ErrorBoundary extends React.Component {

    state = { hasError: false };

    static getDerivedStateFromError(error, prop) {
        return { hasError: true };
    }

    static getDerivedStateFromProps(props, state) {
        // console.log(props, state)
        // return { hasError: true };
    }

    componentDidCatch(error, info) {
        localStorage.removeItem("url");
        localStorage.removeItem("test");
        this.props.dispatch(createErrorEmail(error));
        // logErrorToMyService(error, info.componentStack);
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback;
        }
        return this.props.children;
    };
};


export default connect()(ErrorBoundary);